import type { BundledLanguage, Highlighter, PlainTextLanguage } from 'shiki';

import { DEFAULT_SYNTAX } from './syntaxes';
import { theme } from './theme';

export function tokenizer(
    highlighter: Highlighter,
    code: string,
    lang: BundledLanguage | PlainTextLanguage
) {
    const loadedLang = highlighter.getLoadedLanguages().includes(lang) ? lang : DEFAULT_SYNTAX;
    return highlighter.codeToTokens(code, {
        lang: loadedLang,
        theme,
    });
}

export function getTokenStyles(token: { color?: string }) {
    return token.color ? `color: ${token.color};` : '';
}
